import { render } from "./CenterPiece.vue?vue&type=template&id=6543e2f0&scoped=true"
import script from "./CenterPiece.vue?vue&type=script&lang=js"
export * from "./CenterPiece.vue?vue&type=script&lang=js"

import "./CenterPiece.vue?vue&type=style&index=0&id=6543e2f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6543e2f0"]])

export default __exports__